import {isWizardNode, IWizardNode} from './wizardNode';

export class WizardFocus {
    public subject: any;

    constructor(public node: IWizardNode) { 
        this.subject = node.subjectData;
    }

    public isMatch(node: IWizardNode): boolean {
        return node === this.node && node.subjectData === this.subject;
    }

    public isEqual(focus: WizardFocus): boolean {
        return focus.node.stateName === this.node.stateName && focus.subject === this.subject;
    }
}

export function isWizardFocus(arg: any): arg is WizardFocus {
    return angular.isDefined(arg.node);
}
